import React from 'react'
import { Button } from 'antd';

const Buttons = ({ type = 'primary', icon = null,onClick, children, loading = false, disabled = false, ...props }) => {
    return (
            <Button
                type={type}
                onClick={onClick}
                loading={loading}
                disabled={disabled}
                {...props}
                className='custom-buttons'
                icon={icon}
            >
                {children}
            </Button>
    )
}

export default Buttons
